<div class="planning-display" [style.height]="getPlanningHeight()">
  <ng-content></ng-content>
</div>
